module.exports = __webpack_public_path__ + "img/conf_jitsi.ffc367e9.png";